export function NavBarName({ name }) {
  return (
    <li className="nav__menu-item item-full">
      <p>{name}</p>
    </li>
  );
}
